import React from 'react'
import moment from 'moment'
import { FieldNames } from '../../types/publishSchedule'
import { scheduleModalOpen } from '../../actions/publishSchedule'
import { usePublishSchedule } from './hooks'
import { Space } from '../../layouts'
import { H2, H3, P } from '../StyledText'
import Button from '../StyledButton'
import { AddPublishScheduleModal } from './AddPublishScheduleModal'
import { SchedulesList } from './SchedulesList'
import { DeletePublishScheduleModal } from './DeletePublishScheduleModal'
import { colors } from '../../styles'
import { Overlay } from '../Overlay/Overlay'

interface IAddPublishScheduleArea {
  disableAddPublishSchedule?: boolean
  publishTab?: boolean
}

export const AddPublishScheduleArea = ({
  disableAddPublishSchedule = false,
  publishTab = false,
}: IAddPublishScheduleArea) => {
  const [
    { schedulesLoaded, schedules, isRequestInProgress },
    dispatch,
  ] = usePublishSchedule()
  return (
    <>
      <Space mb={4}>
        <Space mb={2}>
          {publishTab ? <H3>Schedule</H3> : <H2>Publish schedules</H2>}
        </Space>
        {schedulesLoaded && (
          <P>
            {(disableAddPublishSchedule &&
              'To create a schedule ensure the files have a publishing location selected and save the pack.') ||
              (schedules.length === 0 &&
                'No publishing schedules have been created for this pack. To create a schedule ensure the files have a publishing location selected and save the pack.')}
          </P>
        )}
      </Space>
      <Button
        id="add-publish-schedule-button"
        variant="contained"
        color="primary"
        disabled={disableAddPublishSchedule}
        onClick={() => {
          dispatch(
            scheduleModalOpen({
              [FieldNames.startTime]: moment()
                .startOf('minute')
                .add(5, 'minute')
                .toDate(),
            })
          )
        }}
        fullWidth={publishTab}
      >
        Add publish schedule
      </Button>
      <SchedulesList publishTab={publishTab} />
      <Overlay isShown={isRequestInProgress} spinnerColor={colors.green} />
      <AddPublishScheduleModal />
      <DeletePublishScheduleModal />
    </>
  )
}
